import React, { useEffect } from 'react';
import BlockSpacing from '../../../styled/BlockSpacing';
import Container from '../../../styled/Container';
import Distance from '../../../styled/Distance';
import { H2 } from '../../../styled/Heading';
import { addScript } from '../../../utils/script';
import HtmlContent from '../../../components-legacy/HtmlContent';

export interface IFlowboxSlice {
  flowboxKey: string;
  heading?: string;
  titleHeadingLevel?: number;
  content?: string;
}

const initFlowbox = (key: string) => {
  if (key && window.flowbox) {
    window.flowbox('init', {
      container: `#${key}`,
      key,
      locale: 'sv-SE',
    });
  }
};

const FlowboxSlice = ({ heading, flowboxKey: key, titleHeadingLevel, content }: IFlowboxSlice) => {
  useEffect(() => {
    if (!window.flowbox) {
      const f: {
        (): void;
        q: any[];
      } = (...args) => {
        f.q.push(args);
      };
      f.q = [];
      window.flowbox = f;
    }

    addScript({
      src: 'https://connect.getflowbox.com/flowbox.js',
      id: 'flowbox-js-embed',
      onLoad: () => {
        initFlowbox(key);
      },
    });

    initFlowbox(key);
  }, [key]);

  if (!key) {
    return null;
  }

  return (
    <BlockSpacing>
      <Container>
        <Container limitWidth>
          {heading && (
            <>
              <H2 className="text-center" as={titleHeadingLevel === 1 ? 'h1' : undefined}>
                {heading}
              </H2>
              <Distance size="2" />
            </>
          )}
          {content && (
            <>
              <HtmlContent html={content} />
              <Distance size="2" />
            </>
          )}
        </Container>
        <div id={key} />
      </Container>
    </BlockSpacing>
  );
};

export default FlowboxSlice;
